import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';

var Panel = function (_super) {
  __extends(Panel, _super);

  function Panel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Panel = __decorate([Component({})], Panel);
  return Panel;
}(Vue);

export default Panel;